/** Shared preview calculation. Backend platform_core.colli remains authoritative. */
export const VOLUMETRIC_DIVISOR = 6000;

export const measurementNumber = (value) => {
  const n = Number(String(value ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const dimensionMetrics = ({ length, width, height, quantity = 1, unit = "cm" }) => {
  const factor = { cm: 1, m: 100, meter: 100, inch: 2.54, ft: 30.48 }[unit] || 1;
  const [l, w, h, q] = [length, width, height, quantity].map(measurementNumber);
  const cm3 = l > 0 && w > 0 && h > 0 && q > 0 ? l * w * h * factor ** 3 * q : 0;
  return { cbm: cm3 / 1_000_000, volumetric: cm3 / VOLUMETRIC_DIVISOR };
};

export const aggregateMeasurements = (rows) => {
  const totals = { pieces: 0, weight: 0, cbm: 0, volumetric: 0 };
  for (const row of rows || []) {
    const q = Math.max(0, measurementNumber(row.quantity ?? 1));
    const line = dimensionMetrics({ ...row, quantity: q });
    totals.pieces += q;
    totals.weight += measurementNumber(row.weightPerPiece) * q;
    totals.cbm += line.cbm;
    totals.volumetric += line.volumetric;
  }
  return { ...totals, chargeable: Math.max(totals.weight, totals.volumetric),
    basis: totals.volumetric > totals.weight ? "volumetric_weight" : "gross_weight" };
};